<template>
  <div class="auth-wrapper auth-v1">
    <Loading />
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- logo -->
        <v-card-title class="d-flex align-center justify-center py-7">
          <router-link
            to="/"
            class="d-flex align-center"
          >
            <v-img
              :src="require('@/assets/images/logos/logo.png')"
              height="auto"
              width="165px"
              contain
              alt="logo"
              class="me-3 "
            ></v-img>
          </router-link>
        </v-card-title>

        <!-- title -->
        <v-card-text>
          <p class="text-2xl font-weight-semibold text-center text--primary mb-2">
            Welcome to system open holiday
          </p>
          <p class="mb-2 text-center">
            Please sign-in to your account and start <br> create adventure
          </p>
        </v-card-text>

        <!-- login form -->
        <v-card-text>
          <v-form>
            <v-text-field
              v-model="user.email"
              outlined
              label="Email"
              placeholder="blmtour@example.com"
              :error-messages="errors.email"
              hide-details
              class="mb-3"
            ></v-text-field>

            <v-text-field
              v-model="user.password"
              outlined
              :type="isPasswordVisible ? 'text' : 'password'"
              label="Password"
              placeholder="············"
              :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
              hide-details
              :error-messages="errors.password"
              @click:append="isPasswordVisible = !isPasswordVisible"
            ></v-text-field>

            <div class="d-flex align-center justify-space-between flex-wrap">
              <v-checkbox
                label="Remember Me"
                hide-details
                class="me-3 mt-1"
              >
              </v-checkbox>

              <!-- forgot link -->
              </div>

            <v-btn
              :loading="loading"
              block
              color="primary text-capitalize"
              class="mt-6"
              @click="ProsesLogin()"
            >
              Let's Sign-In
            </v-btn>
          </v-form>
        </v-card-text>

        <!-- create new account  -->
      </v-card>
    </div>

    <!-- background triangle shape  -->
    <img
      class="auth-mask-bg"
      height="173"
      :src="require(`@/assets/images/misc/mask-${$vuetify.theme.dark ? 'dark':'light'}.png`)"
    >

    <!-- tree -->
    <v-img
      class="auth-tree"
      width="247"
      height="185"
      src="@/assets/images/misc/tree-4.png"
    ></v-img>

    <!-- tree  -->
    <v-img
      class="auth-tree-3"
      width="377"
      height="289"
      src="@/assets/images/misc/tree-3.png"
    ></v-img>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiFacebook, mdiTwitter, mdiGithub, mdiGoogle, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import axios from 'axios'
import Loading from '@/components/Loading.vue'

export default {
  setup() {
    const isPasswordVisible = ref(false)
    const email = ref('')
    const password = ref('')
    const socialLink = [
      {
        icon: mdiFacebook,
        color: '#4267b2',
        colorInDark: '#4267b2',
      },
      {
        icon: mdiTwitter,
        color: '#1da1f2',
        colorInDark: '#1da1f2',
      },
      {
        icon: mdiGithub,
        color: '#272727',
        colorInDark: '#fff',
      },
      {
        icon: mdiGoogle,
        color: '#db4437',
        colorInDark: '#db4437',
      },
    ]

    return {
      isPasswordVisible,
      email,
      password,
      socialLink,
      loading: false,
      errors: [],
      user: {
        email: '',
        password: '',
      },
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
  components: { Loading },
  mounted() { },
  methods: {
    ProsesLogin() {
      this.loading = true
      this.$root.$emit('PesanLoading', 'Proses Login')
      axios.post('/Login', this.user).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        localStorage.setItem('token', response.data.data.access_token)
        this.$store.commit('setUser', response.data.data)
        this.$router.push('/Dashboard')
      }).catch(err => {
        this.errors = err.response.data.errors

        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
      this.loading = false
    },
  },
}

</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>
